import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DisabledByDefaultIcon(props: IconProps) {
    return <Icon {...props} iconKey={"disabled_by_default"}/>
}
